export const CLIENT_ID_PATTERN = /^[A-Za-z0-9]{8,15}$/;
export const CLIENT_PORTAL_HOST = 'client.butlerdelivery.live';

function normalizeClientId(value) {
  const clientId = String(value || '').trim();
  return CLIENT_ID_PATTERN.test(clientId) ? clientId : '';
}

export function extractClientId(input) {
  const value = String(input || '').trim();
  if (!value) return '';

  if (!value.includes('://')) return normalizeClientId(value);

  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.hostname !== CLIENT_PORTAL_HOST)
      return '';
    const segments = url.pathname.split('/').filter(Boolean);
    return segments.length === 1 ? normalizeClientId(segments[0]) : '';
  } catch {
    return '';
  }
}

export function getClientIdFromPath(pathname) {
  const segments = String(pathname || '')
    .split('/')
    .filter(Boolean);
  return segments.length === 1 ? normalizeClientId(segments[0]) : '';
}
